
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conf/2025/[speaker]",
      function () {
        return require("private-next-pages/conf/2025/[speaker].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conf/2025/[speaker]"])
      });
    }
  